import { combineReducers } from "@reduxjs/toolkit";
import productListReducer from "./product-list";

const productReducer = combineReducers({
    productList: productListReducer
})

export { productReducer }